<div class="page gray-font-color font-family full-height">
  <div class="header-navigation" >
    <span>FleetOperate</span>
  </div>

  <div class="id-card-container" >
    <div class="section-one">
      <span class="title font-family padding-left-sm padding-top-lg">FLEETOPERATE Driver</span>
      <span class="driver-name font-family padding-left-sm" data-test="driver-name-in-card">{{ driverName }}</span>
    </div>
    <div class="section-two"></div>
    <div class="section-three" >
      @if (!driverPicture) {
        <div class="circle-div">
          <mat-icon>person</mat-icon>
        </div>
      }
      @if (driverPicture) {
        <div class="circle-div">
          <img class="profile-picture" [src]="driverPicture" />
        </div>
      }
      <span class="driver-id font-family padding-top-md" data-test="driver-id-in-card">{{ driverId }}</span>
    </div>
  </div>
</div>
@if (!profileCompleted && !loading) {
  <div>
    <app-actions
      [actions]="actions"
      class="margin-top-lg"
      [ngClass]="showNavBar ? 'fixed-bottom' : 'native-app-fixed-bottom'"
    ></app-actions>
  </div>
}
